import { getIcon } from "../../Utils/Global";

// Returns theme properties
export const getThemeProperties = (key = undefined) => {
  if (sessionStorage["theme-default"]) {
    let theme = JSON.parse(sessionStorage["theme-default"]);
    let landingPageTheme = theme?.landingPage;

    if (landingPageTheme) {
      if (landingPageTheme[key]) {
        return landingPageTheme[key];
      } else {
        return null;
      }
    }
  }

  return null;
};

// Returns theme button properties
export const getButtonThemeProperties = (key = undefined, isActive = false) => {
  if (sessionStorage["theme-default"]) {
    let theme = JSON.parse(sessionStorage["theme-default"]);
    let landingPageTheme = theme?.landingPage;
    let buttons = landingPageTheme?.buttons ? landingPageTheme?.buttons : {};
    let relatedButton = buttons[key];

    if (relatedButton) {
      if (isActive) {
        return {
          background: relatedButton.backgroundColorActive,
          color: relatedButton.textColorActive,
          display: relatedButton.visibility == false ? "none" : "",
          border: `1px solid ${relatedButton.textColorActive}33`,
        };
      } else {
        return {
          background: relatedButton.backgroundColor,
          color: relatedButton.textColor,
          display: relatedButton.visibility == false ? "none" : "",
          border: `1px solid ${relatedButton.textColor}33`,
        };
      }
    }
  }

  return null;
};

// Returns icons
export const getLandingPageIcon = (key) => {
  if (sessionStorage["theme-default"]) {
    let theme = JSON.parse(sessionStorage["theme-default"]);
    let landingPageTheme = theme?.landingPage;
    let buttons = landingPageTheme?.buttons ? landingPageTheme?.buttons : {};
    let relatedButton = buttons[key]?.icon;

    if (relatedButton) {
      return getIcon(relatedButton, null, { marginRight: "5px" });
    }

    return null;
  }

  return null;
};
